import { CameraStatus } from "@/constants/camera-status";
import moment from "moment";

import { Camera } from "./Camera";

export class CameraGroup {
  constructor(
    id = "",
    name = "",
    userId = "",
    organization = "",
    cameras = [],
    createdAt = null,
    updatedAt = null,
    description = "",
    camerasInfo = [],
    modelId = "",
    datasetId = "",
    connectionStatus = "",
    datasetName = "",
    modelName = "",
    size = 0,
    taskType = ""
  ) {
    /** @type {string} */
    this.id = id;

    /** @type {string} */
    this.name = name;

    /** @type {string} */
    this.userId = userId;

    /** @type {string} */
    this.organization = organization;

    /** @type {string[]} */
    this.cameras = cameras;

    /** @type {Date} */
    this.createdAt = moment(createdAt).format("DD-MM-YYYY,  HH:mmA");

    /** @type {Date} */
    this.updatedAt = moment(updatedAt).format("DD-MM-YYYY,  HH:mmA");

    /** @type {string} */
    this.description = description;

    /** @type {Camera[]} */
    this.camerasInfo = camerasInfo ? camerasInfo.map((camera) => Camera.fromApi(camera)) : [];

    /** @type {string} */
    this.modelId = modelId;

    /** @type {string} */
    this.datasetId = datasetId;

    /** @type {string} */
    this.connectionStatus = connectionStatus;

    /** @type {string} */
    this.datasetName = datasetName;

    /** @type {string} */
    this.modelName = modelName;

    /** @type {boolean} */
    this.connected = connectionStatus === CameraStatus.CONNECTED;

    /** @type {number} */
    this.size = +size;

    /**@type {string} */
    this.taskType = taskType;
  }

  /**
   * @param {Object} apiRes
   * @returns {CameraGroup}
   * @memberof CameraGroup
   * @description transform the api response to a CameraGroup object
   */
  static fromApi(apiRes) {
    return new CameraGroup(
      apiRes._id,
      apiRes.name,
      apiRes.user_id,
      apiRes.organization,
      apiRes.cameras,
      apiRes.created_at,
      apiRes.updated_at,
      apiRes.description,
      apiRes.cameras_info,
      apiRes.model_id,
      apiRes.dataset_id,
      apiRes.connection_status,
      apiRes.dataset_name,
      apiRes.model_name,
      apiRes.size,
      apiRes.task_type
    );
  }
}
